import { PublishNotificationsDictionary } from './PublishTestPanel.interfaces';
import { NOTIFY_TYPES } from './PublishTestPanel.types';

export const PublishNotificationsDict: PublishNotificationsDictionary = {
  [NOTIFY_TYPES.EACH.toString()]: NOTIFY_TYPES.EACH,
  [NOTIFY_TYPES.ALL.toString()]: NOTIFY_TYPES.ALL,
  [NOTIFY_TYPES.NONE.toString()]: NOTIFY_TYPES.NONE
};

export const TODAY = new Date().toLocaleDateString();